<div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="center" fxLayout="row" fxLayoutAlign="space-around center">
        <mat-card class="data-cards blue-card">
            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Vacation
            </mat-card-subtitle>
            <table class="top-tables">
                <tr>
                    <th id="total-days" class="top-table-headings">TOTAL DAYS</th>
                    <td>{{getDisplayValueVacation.get('total')}}</td>
                </tr>
                <tr>
                    <th id="remaining" class="top-table-headings">REMAINING DAYS</th>
                    <td>{{getDisplayValueVacation.get('remaining')}}</td>
                </tr>
                <tr>
                    <th id="pending" class="top-table-headings">PENDING DAYS</th>
                    <td>{{getDisplayValueVacation.get('pending')}}</td>
                </tr>
                <tr>
                    <th id="carry-over" class="top-table-headings">CARRYOVER</th>
                    <td>{{getDisplayValueVacation.get('carryover')}}</td>
                </tr>
            </table>
        </mat-card>
        <br/>
        <mat-card class="data-cards green-card">
            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Employee Details
            </mat-card-subtitle>
            <table class="top-tables">
                <tr>
                    <th id="first-name" class="top-table-headings">First Name</th>
                    <td>{{selectedData[1].firstName | titlecase}}</td>
                </tr>
                <tr>
                    <th id="last-name" class="top-table-headings">Last Name</th>
                    <td>{{selectedData[1].lastName | titlecase}}</td>
                </tr>
                <tr>
                    <th id="gmin" class="top-table-headings">GMIN</th>
                    <td>{{selectedData[1].gmin}}</td>
                </tr>
                <tr>
                    <th id="date-started" class="top-table-headings">Date Started</th>
                    <td>{{selectedData[1].startDate | date: 'dd/MM/yyyy'}}</td>
                </tr>
                <tr>
                    <th id="contract-type" class="top-table-headings">Contract Type</th>
                    <td>{{selectedData[1].contractType | titlecase  | removeUnderscorePipe }}</td>
                </tr>
                <tr>
                    <th id="teams" class="top-table-headings">Teams</th>
                    <td>{{selectedData[1].teamName}}</td>
                </tr>
                <tr>
                    <th id="email" class="top-table-headings">Email</th>
                    <td>{{selectedData[1].email}}</td>
                </tr>
            </table>
        </mat-card>
        <br/>
        <mat-card class="data-cards red-card">
            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle">Work Abroad
            </mat-card-subtitle>
            <table class="top-tables">
                <tr>
                    <th class="top-table-headings">TOTAL DAYS</th>
                    <td>{{getDisplayValueWork.get('total')}}</td>
                </tr>
                <tr>
                    <th class="top-table-headings">REMAINING DAYS</th>
                    <td>{{getDisplayValueWork.get('remaining')}}</td>
                </tr>
                <tr>
                    <th class="top-table-headings">PENDING DAYS</th>
                    <td>{{getDisplayValueWork.get('pending')}}</td>
                </tr>
                <tr>
                    <th class="top-table-headings">NEGATIVE CARRYOVER</th>
                    <td>{{getDisplayValueWork.get('negativeCarryover')}}</td>
                </tr>
            </table>
        </mat-card>
    </div>
</div>
<br/>
<mat-form-field fxLayoutAlign="center">
    <mat-label>Year</mat-label>
    <mat-select #selectedYear
                [(value)]="filterEntity.year"
                (selectionChange)="calculateCardValues(selectedYear.value)">
        <mat-option *ngFor="let model of selectedData[2]"
                    value="{{model}}">{{model}}</mat-option>
    </mat-select>
</mat-form-field>
<br/>
<div>
    <mat-tab-group #tabChange>
        <mat-tab label="Personal">
            <div fxLayout="row" fxLayoutAlign="center">
                <mat-table [dataSource]="dataSourceVacation" matSort matTableFilter
                           [exampleEntity]="filterEntity" #vacationSort>
                    <ng-container *ngFor="let field of fieldNames;let i=index"
                                  matColumnDef="{{field}}">
                        <th id="headers" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                            class="mat-column-headers-standard">
                            {{displayNames[i]}}
                        </th>
                        <td mat-cell *matCellDef="let vacation" class="mat-column-standard center-text">
                            <div *ngIf="field=='dateCreated'">
                                {{vacation[field] | date: 'dd/MM/yyyy'}}
                            </div>
                            <div *ngIf="field=='halfDay'">
                                {{halfDayStatus(vacation[field])}}
                            </div>
                            <div *ngIf="field=='startDate'">
                                {{vacation[field] | date: 'dd/MM/yyyy'}}
                            </div>
                            <div *ngIf="field=='endDate'">
                                {{vacation[field] | date: 'dd/MM/yyyy'}}
                            </div>
                            <div *ngIf="field=='holidayTaken' ">
                                {{vacation[field]}}
                            </div>
                            <div *ngIf="field=='numberOfAnnualLeaveDays'">
                                {{vacation[field]}}
                            </div>
                            <div *ngIf="field!=='dateCreated' && field!=='startDate' && field!=='endDate' && field!=='holidayTaken'&& field !=='halfDay' && field!=='numberOfAnnualLeaveDays' && field!=='absenceType' && field!=='absenceReason'">
                                {{vacation[field] | titlecase}}
                            </div>
                            <div *ngIf="field=='absenceReason' && vacation['absenceReason'].length <= 25">
                                {{vacation[field]}}
                            </div>
                            <div *ngIf="field=='absenceReason' && vacation['absenceReason'].length > 25"
                                 matTooltip="{{vacation[field]}}"
                                 matTooltipPosition="left">
                                {{vacation[field].slice(0, 25) + '...'}}
                            </div>
                            <div *ngIf="field=='absenceType'">
                                {{ vacation[field] | titlecase | removeUnderscorePipe }}
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="fieldNames; sticky: true;"></tr>
                    <tr mat-row
                        *matRowDef="let row = row; let even = even; columns: fieldNames;"
                        [ngClass]="{blueBackground : even}"></tr>
                </mat-table>
            </div>
        </mat-tab>
        <br/>
        <mat-tab label="Work Abroad">
            <div fxLayout="row" fxLayoutAlign="center">
                <mat-table [dataSource]="dataSourceWork" matSort matTableFilter
                           [exampleEntity]="filterEntity" #workAbroadSort>
                    <ng-container *ngFor="let field of fieldNamesWork;let i=index"
                                  matColumnDef="{{field}}">
                        <th mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                            class="mat-column-headers-standard">
                            {{displayNamesWork[i]}}
                        </th>
                        <td mat-cell *matCellDef="let workAbroad" class="mat-column-standard center-text">
                            <div *ngIf="field=='dateCreated'">
                                {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                            </div>
                            <div *ngIf="field=='startDate'">
                                {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                            </div>
                            <div *ngIf="field=='endDate'">
                                {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                            </div>
                            <div *ngIf="field=='numberOfWorkAbroadDays'">
                                {{workAbroad[field]}}
                            </div>
                            <div *ngIf="field=='numberOfAnnualLeaveDays'">
                                {{workAbroad[field]}}
                            </div>
                            <div *ngIf="field !='numberOfWorkAbroadDays' && field!=='startDate' && field!=='endDate' && field !='dateCreated' && field !='numberOfAnnualLeaveDays'">
                                {{workAbroad[field] | titlecase}}
                            </div>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="fieldNamesWork; sticky: true;"></tr>
                    <tr mat-row
                        *matRowDef="let row = row; let even = even; columns: fieldNamesWork;"
                        [ngClass]="{blueBackground : even}"></tr>
                </mat-table>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
